'use strict';

var title = 'Rakuten Travel - Get the best deals on Japanese Hotels and Ryokans';

module.exports = {
  protocol: 'https',
  host: process.env.HOST || 'travel.rakuten.com',
  // TODO: process.env.PORT is always undefined
  port: parseInt(process.env.PORT, 10) || 3000,
  app: {
    entry: '/', // this URI will be use to generate static page
    context: 'm17n',
    title: title,
    head: {
      titleTemplate: title + ' - %s',
      meta: [{ charset: 'utf-8' }]
    }
  },
  // TODO: perhaps we should get this from API
  defaultCurrencies: {
    'travel.rakuten.com': 'USD',
    'travel.rakuten.com.tw': 'TWD',
    'travel.rakuten.cn': 'CNY',
    'travel.rakuten.com.hk': 'HKD',
    'travel.rakuten.co.kr': 'KRW',
    'travel.rakuten.co.th': 'THB',
    'travel.rakuten.co.id': 'IDR',
    'travel.rakuten.com.sg': 'SGD',
    'travel.rakuten.com.my': 'MYR',
    'travel.rakuten.fr': 'EUR',
    'travel.rakuten.co.jp': 'JPY'
  },
  urls: {
    // routes that are handled by react-router
    // should be placed in <Link to={urls.app.root}></Link>
    app: {
      root: '/',
      country: '/hotellist/:countryID',
      subdivision: '/hotellist/:countryID-:subdivisionID',
      city: '/hotellist/:countryID-:subdivisionID-:cityID',
      spot: '/hotellist/:countryID-:subdivisionID-:cityID-:spotID',
      oldSpot: '/spot/:countryID-:subdivisionID-:cityID-:spotID/:spotCode',
      hotellist: '/hotellist/:areaID',
      oldHotellist: '/hotellist/:areaID/:areaCode',
      hotel: '/hotel/:areaID/:hotelID',
      simpleHotel: '/hotel/info/:hotelID'
    },
    api: {
      banner: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/banner',
      breadcrumbs: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/breadcrumbs',
      currencies: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/currencies',
      hotels: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/hotels',
      member: 'https://grid.travel.rakuten.com.tw/member/memberUserName',
      navigations: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/navigations',
      point: 'https://grid.travel.rakuten.com.tw/member/point',
      rooms: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/hotels/:id/rooms',
      seo: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/:lang/seo',
      sites: 'https://app.rakuten.co.jp/engine/dapi/Travel/MultilingualHotelSearch/ghotel/v4/en_US/sites',
      suggest: 'https://trv.r10s.jp/m17n/ghotel/js/suggest-data_:lang.js?version=1.0.6',
      // json files
      explanations: ':host/json/v1/:lang/explanations',
      notifications: ':host/json/v1/:lang/notifications',
      signatures: ':host/json/v1/:lang/signatures/:countryID',
      recommendations: ':host/json/v1/:lang/recommendations',
      topDestinations: ':host/json/v1/:lang/topDestinations/:countryID',
      features: ':host/json/v1/:lang/features'
    },
    // routes that are placed in <a href={urls.external.cars}></a>
    external: {
      // original travel site
      cars: '/cars',
      campaign: '/campaign',
      activities: '/activities',
      // rakuten
      // booking: 'https://book.travel.rakuten.com/booking/?id_hotel=41069&id_plan=3485765&id_room=sds2&checkin_date=2016-12-15&checkout_date=2016-12-16&rooms=1&adults=2',
      booking: 'https://book.travel.rakuten.:ccSLD/booking/',
      bookingSignin: 'https://book.travel.rakuten.:ccSLD/itinerary/signin',
      sitemap: '//travel.rakuten.:ccSLD/sitemap/',
      conditions: '//travel.rakuten.:ccSLD/info/conditions/',
      myBooking: 'https://book.travel.rakuten.:ccSLD/itinerary/mybookings',

      about: '//global.rakuten.com/corp/',
      faq: '//rakuten-travel-en.custhelp.com/',

      privacy: '//privacy.rakuten.co.jp/english/',
      // # ONLY PROVIDE FOR TW
      signin: 'https://grid.travel.rakuten.com.tw/member/signin',
      signout: 'https://grid.travel.rakuten.com.tw/member/signout',
      register: 'https://grid.travel.rakuten.com.tw/member/register',
      myPage: 'https://grid.travel.rakuten.com.tw/member/myPage',
      point: 'https://secure.rakuten.com.tw/point'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 1231
// module chunks = 0